/**
 * Application Line-2 peers (same SubPageNav style as buildings).
 * Overview · Apply BWOF · Amend CS List
 */

export function getApplicationPeerNav(pathname) {
  const peers = [
    { id: 'overview', label: 'Overview', to: '/application' },
    { id: 'apply-bwof', label: 'Apply BWOF', to: '/application/apply-bwof' },
    {
      id: 'amend-cs',
      label: 'Amend CS List',
      to: '/application/amend-compliance-schedules',
    },
  ];
  const activeId = detectApplicationPeer(pathname);
  return peers.map((p) => ({ label: p.label, to: p.to, active: p.id === activeId }));
}

function detectApplicationPeer(pathname) {
  const p = pathname || '';
  if (p.startsWith('/application/apply-bwof')) return 'apply-bwof';
  if (
    p.startsWith('/application/amend-compliance-schedules') ||
    p.startsWith('/application/amend-ss-site-visit')
  ) {
    return 'amend-cs';
  }
  if (p === '/application') return 'overview';
  return 'overview';
}

export function resolveApplicationNav({ pathname }) {
  const p = pathname || '';
  if (p === '/application') {
    return { trail: [], subPages: getApplicationPeerNav(p) };
  }
  if (p.startsWith('/application/amend-ss-site-visit')) {
    return {
      trail: [
        { label: 'Application', to: '/application' },
        { label: 'Amend CS List', to: '/application/amend-compliance-schedules' },
      ],
      subPages: getApplicationPeerNav(p),
    };
  }
  return {
    trail: [{ label: 'Application', to: '/application' }],
    subPages: getApplicationPeerNav(p),
  };
}
